import React, { useEffect, useState } from 'react';
import Div100Vh from 'react-div-100vh';
import { useHistory, useLocation } from 'react-router';
import { EpicSpinner } from '../../components';
import {passwordReset} from '../../services/authSvc';

import { ReactComponent as BackArrow } from '../../styles/svg-components/back-arrow.svg';
import { IconButton } from '../../components';

import './ResetPassword.scss'

const ResetPassword = () => {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(null)
  const [token, setToken] = useState(null)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (!!location) {
      const tok = new URLSearchParams(location.search).get('token')
      if (tok) {
        setToken(tok)
      }
    }
  }, [location])

  const handleChange = (event) => {
    if (success === false) {
      setSuccess(null)
    }
    if (event) {
      const {target} = event
      if (target) {
        const {name, value} = target

        switch(name) {
          case 'password': setPassword(value || ''); break;
          case 'confirm': setConfirm(value || ''); break;
          default: break;
        }
      }

    }
  }

  const goToLogin = () => window.location.href = `mm3d://dashboard`;

  const submit = async () => {
    setLoading(true)
    try {
      const result = await passwordReset(token, password)
      setSuccess(true)
    } catch(err) {
      console.error(err)
      setSuccess(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Div100Vh className="reset-password" id="content">
      <div className="header">
        <IconButton icon={() => <BackArrow className="back-arrow"></BackArrow>} onClick={() => history && history.goBack()}></IconButton>
        <h1>Reset Password</h1>
      </div>
      {!!token ?
        <>
          {success !== true &&
          <>
            <form className="reset-form" noValidate>
              <label></label>
              <input type="password" name="password" value={password} onChange={(e) => handleChange(e)} placeholder="Password" autoComplete="new-password"/>
              <label></label>
              <input type="password" name="confirm" value={confirm} onChange={(e) => handleChange(e)} placeholder="Confirm Password" autoComplete="new-password"/>
              {password !== confirm && <p className="error">Passwords don{`'`}t match</p>}
              {success === false && <p className="error">Password reset failed :(</p>}
            </form>
            <button type="submit" onClick={() => submit()} disabled={!password || !confirm || (password !== confirm) || !!loading}>Submit</button>
          </>
          }
          {success === true && 
            <>
              <p>Your password has been reset</p>
              <button onClick={goToLogin}>Click to go to the App</button>
            </>
          }
          {!!loading && <EpicSpinner />}
        </> 
        : 
        <>
        {location && <p className="error">looks like you are missing a password reset token in the URL</p>}
        </>
      }
    </Div100Vh>
  )
}

export default ResetPassword